import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import { urlUploadFile } from "constants/urls";
import { NormativaContext } from "containers/Pymes/emision/PymesEmisionContratante";
import useCustomToast from "hooks/useCustomToasts";
import React, { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import PRODUCTOS from "utils/constants/PRODUCTOS";

import { v4 as uuidv4 } from "uuid";

/**
 *
 * @param {{campo:import("components/DynamicForm/typedefs").Campo}} props
 * @returns
 */
const Archivos = ({
  producto,
  campo,
  estados = { aprobado: 1, pendiente: 2, revision: 3 },
}) => {
  const ref = useRef(null);

  const [uploading, setUploading] = useState(false);
  const { addWarningToast } = useCustomToast();
  const { setValue, watch } = useFormContext();
  const { estadoNormativa, setEstadoNormativa } = useContext(NormativaContext);
  const uploadFile = () => {
    ref.current.click();
  };

  const onChangeFiles = (field) => (e) => {
    debugger;
    if (e.target.files.length !== 0) {
      try {
        const formData = new FormData();

        const file = e.target.files[0];
        if (file.size / 1000 > campo?.maxFileSize) {
          addWarningToast(`El tamaño máximo es: ${campo.maxFileSize}KB`);
          return;
        }
        const splits = file.name?.split(".");

        const lastSplit = splits.length;

        const type = splits[lastSplit - 1];

        const filename = file.name
          .toLowerCase()
          .replace(`.${type}`, `${uuidv4()}.${type}`);

        formData.append("file", e.target.files[0]);
        formData.append("filename", filename);

        setUploading(true);

        if (producto === PRODUCTOS.PYMES) {
          formData.append("credentials", "documentosNormativa");
        }

        fetch(urlUploadFile, {
          method: "POST",
          body: formData,
        })
          .then((res) => res.json())
          .then((res) => {
            ref.current.value = null;
            setUploading(false);
            if (res?.transaccion) {
              if (!estadoNormativa?.[campo.name]?.modificado) {
                field.value = [];
              }
              field.value = [res?.url];
              setEstadoNormativa({
                ...estadoNormativa,
                [`${campo.name}`]: {
                  ...estadoNormativa[`${campo.name}`],
                  modificado: true,
                },
              });
              setValue(campo.name, field.value, { shouldValidate: true });
            }
          })
          .catch((err) => {
            setUploading(false);
          });
      } catch (error) {
        setUploading(false);
      }
    }
  };

  const htmlMessage = (mssg) => {
    return (
      <div
        style={{}}
        dangerouslySetInnerHTML={{
          __html: mssg,
        }}
      />
    );
  };

  const value = useWatch({ name: campo.name });

  return (
    <div className='row col-12 p-2 m-2 border text-bolder font-20px'>
      <Controller
        name={campo.name}
        rules={campo.rules}
        defaultValue={[]}
        render={(field) => {
          return (
            <React.Fragment>
              <div className='d-flex justify-content-between align-items-center flex-row w-100 mt-3'>
                {watch(`documentosNormativa.${campo.name}`) && (
                  <div className='d-flex flex-column justify-content-start align-items-top h-100 w-100 mt-3'>
                    {estadoNormativa?.estadoNormativaCorrecto * 1 ===
                      estados.aprobado && <div className={"img-input-ok "}>&nbsp;</div>}
                    {estadoNormativa?.estadoNormativaCorrecto * 1 ===
                      estados.pendiente && (
                      <div className={"img-input-pendiente "}>&nbsp;</div>
                    )}
                    {estadoNormativa?.estadoNormativaCorrecto * 1 ===
                      estados.revision && (
                      <>
                        {" "}
                        {!estadoNormativa?.[campo.name]?.estado ? (
                          <div
                            title={
                              estadoNormativa?.[campo.name]?.modificado !== true
                                ? estadoNormativa?.[campo.name]?.observaciones
                                : "Aprobación Pendiente"
                            }
                            className={`img-input-${
                              !estadoNormativa?.[campo.name]?.modificado
                                ? "error"
                                : "pendiente"
                            }`}>
                            &nbsp;
                          </div>
                        ) : (
                          <div className={"img-input-ok "}>&nbsp;</div>
                        )}
                      </>
                    )}
                  </div>
                )}

                <div className='d-flex flex-column justify-content-center col-10'>
                  <label
                    className='align-self-left bolder font19px'
                    style={{ fontFamily: "Futura-Medium" }}>
                    {htmlMessage(campo.label)}
                  </label>
                  <SimpleErrorMessage name={campo.name} />
                </div>
                <Button
                  variant='primary'
                  className='font-16px'
                  disabled={
                    uploading ||
                    estadoNormativa?.[campo.name]?.estado === true ||
                    (estadoNormativa?.[campo.name]?.estado || estados.revision) * 1 !==
                      estados.revision
                  }
                  onClick={uploadFile}>
                  {!uploading ? "Cargar archivo" : "Cargando......"}
                </Button>
                <input
                  type='file'
                  ref={ref}
                  hidden
                  multiple={false}
                  onChange={onChangeFiles(field)}
                  disabled={
                    uploading ||
                    estadoNormativa?.[campo.name]?.estado === true ||
                    (estadoNormativa?.[campo.name]?.estado || estados.revision) * 1 !==
                      estados.revision
                  }
                />
              </div>
            </React.Fragment>
          );
        }}
      />
      <div
        className='d-flex flex-column justify-content-end w-100 mt-3 col-12'
        style={{ textAlign: "right" }}>
        {value &&
          typeof value === "object" &&
          value?.map((file, index) => (
            <div
              className='my-1 font16px d-flex flex-wrap justify-content-end row'
              key={index}>
              <div className='col-6 text-left d-flex flex-wrap'>
                <a
                  className='mx-2 btn btn-aigmex-outlined text-truncate font-16px col'
                  href={file}
                  // style={{ maxWidth: "150px" }}
                  disabled={uploading}
                  target='_blank'
                  rel='noopener noreferrer'>
                  {file?.replace?.(
                    "https://aigmex-backup-doc-cumplimiento.s3.us-west-2.amazonaws.com/dev/",
                    ""
                  )}
                </a>
                <button
                  className='btn font-16px mx-2 mb-3'
                  type='button'
                  onClick={() => {
                    const newFiles = value?.filter((item) => item !== file);
                    setValue(campo.name, newFiles, { shouldValidate: true });
                    ref.current.value = newFiles;
                  }}
                  disabled={
                    uploading ||
                    estadoNormativa?.[campo.name]?.estado === true ||
                    (estadoNormativa?.[campo.name]?.estado || estados.revision) * 1 !==
                      estados.revision
                  }>
                  <i className='pi pi-times' />
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Archivos;
